import { AdminLayout, useTranslation } from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { GeneralOptions } from "../../features/administration";

export const GeneralManagePage = observer(() => {
  const t = useTranslation();

  return (
    <AdminLayout contentPadding>
      <AdminToolbar title={t("maintenance:administration.general.headline")} />
      <div className="od-page-main">
        <GeneralOptions />
      </div>
    </AdminLayout>
  );
});
